export default __webpack_public_path__ + "static/media/RecipeApp.7d878472.gif";